import { z } from 'zod';

// AIDEV-NOTE: Payload do PUT /api/v1/admin/politicas-clientes/:clienteErpId
export const upsertPoliticaClienteSchema = z.object({
  limite_desconto_pct: z.number().min(0).max(100)
});

export type UpsertPoliticaClienteDto = z.infer<typeof upsertPoliticaClienteSchema>;
